var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-header"},[_c('div',{staticClass:"header-title"},[_vm._v("云志影藏后台管理系统")]),_c('div',{staticClass:"info-view"},[_c('div',{staticClass:"jk-mr-10"},[_vm._v(_vm._s(_vm.$store.state.userName))]),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":_vm.logout}},[_vm._v("退出")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }